/*
 *
 * ReportExport reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_EXPORT_REPORT_FAILED,
  GET_EXPORT_REPORT_SUCCESS,
  GET_EXPORT_REPORT_WATCHER,
  GET_MEDITIONS_REPORT_EXPORT_SUCCESS,
  GET_MEDITIONS_REPORT_EXPORT_WATCHER,
  GET_DIVISIONS_AMBASSADOR_REPORT_EXPORT_WATCHER,
  GET_DIVISIONS_AMBASSADOR_REPORT_EXPORT_SUCCESS,
} from "./constants"

export const initialState = fromJS({
  loadingMeditionsExport: true,
  meditions_export: [],
  configuration: {},
  export_url: "",
  exportLoading: false,
  export_success: false,
  divisions_ambassador: [],
  loadingDivisionsAmbassador: false,
})

function reportExportReducer(state = initialState, action) {
  switch (action.type) {
    case GET_MEDITIONS_REPORT_EXPORT_WATCHER:
      return state
        .set("loadingMeditionsExport", true)
        .set("meditions_export", [])
    case GET_MEDITIONS_REPORT_EXPORT_SUCCESS:
      return state
        .set("loadingMeditionsExport", false)
        .set("meditions_export", action.payload.meditions)
        .set("configuration", action.payload.configuration)
    case GET_EXPORT_REPORT_WATCHER:
      return state
        .set("exportLoading", true)
        .set("export_url", "")
        .set("export_success", false)
    case GET_EXPORT_REPORT_SUCCESS:
      return state
        .set("exportLoading", false)
        .set("export_url", action.payload.url)
        .set("export_success", true)
    case GET_EXPORT_REPORT_FAILED:
      return state
        .set("exportLoading", false)
        .set("export_url", "")
        .set("export_success", false)

    case GET_DIVISIONS_AMBASSADOR_REPORT_EXPORT_WATCHER:
      return state
        .set("divisions_ambassador", [])
        .set("loadingDivisionsAmbassador", true)

    case GET_DIVISIONS_AMBASSADOR_REPORT_EXPORT_SUCCESS:
      return state
        .set("divisions_ambassador", action.payload.divisions)
        .set("loadingDivisionsAmbassador", false)

    default:
      return state
  }
}

export default reportExportReducer
